<template>
  <div>
    <b-row>
      <b-col lg="12">
        <template>
          <div>
            <b-link
              style="font-size: 26px; color: #fff;"
              :to="`/wim-detail?wid=${this.$route.query.wid}`"
            >
              <feather-icon
                style="margin-bottom: 5px;"
                size="26"
                icon="ArrowLeftIcon"
              /> <span style="font-size:20px; color: #ffffff;">รายละเอียดข้อมูลรถเข้าชั่งหนัก WIM ({{ StationName }})</span>
            </b-link>
          </div>
          <b-card-code>
            <b-row>
              <b-col
                md="3"
                class="d-flex align-items-center justify-content-end"
              >
                <label style="padding-right:14px; font-size: 15px">จาก</label>
                <b-form-group style="padding-right:14px">
                  <flat-pickr
                    v-model="date.dateFrom"
                    class="form-control"
                    @input="getHistory"
                  />
                </b-form-group>
                <label style="padding-right:14px; font-size: 15px">ถึง</label>
                <b-form-group>
                  <flat-pickr
                    v-model="date.dateTo"
                    class="form-control"
                    @input="getHistory"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                class="text-sm-right mb-1"
              />
              <b-col
                md="4"
                class="d-flex align-items-center justify-content-start mb-1"
              >
                <label>ค้นหา</label>
                <b-input-group
                  size="sm"
                  style="padding-left:14px;"
                >
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                    label-cols-sm="12"
                    label-cols-md="2"
                    label-cols-lg="2"
                  />
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                    >
                      ล้าง
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <!-- <b-col
                md="1"
                class="text-sm-right mb-1"
              >
                <b-button
                  id="toggle-btn"
                  v-b-modal="'modalReport'"
                  size="sm"
                  variant="primary"
                  @click="$refs.childref.getHistory(date)"
                >
                  Export PDF
                </b-button>
              </b-col> -->
              <b-col cols="12">
                <b-table
                  id="table"
                  responsive
                  :per-page="perPage"
                  :current-page="currentPage"
                  :items="items"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(modal)="data">
                    <b-link
                      v-b-modal="'modalComment'"
                      class="mr-1"
                      @click="$refs.comment.sendInfo(data.item.imei)"
                    >
                      <feather-icon
                        icon="InfoIcon"
                        size="18"
                      />
                    </b-link>
                  </template>
                  <template #cell(IsOverWeight)="data">
                    <b-badge
                      style="font-size: 13px;"
                      :variant="IsOverWeight[1][data.value]"
                    >
                      {{ IsOverWeight[0][data.value] }}
                    </b-badge><br>
                    <span style="font-size: 10px;"> {{ data.item.IsOverWeight }}</span>
                  </template>
                  <template #cell(VehicleClass)="data">
                    <b-img
                      :src="require('@/assets/images/vclass/'+ data.value)"
                      height="30px"
                    />
                  </template>
                  <template #cell(Image01Name)="data">
                    <b-img
                      :src="data.item.Image01Name"
                      width="100px"
                      fluid
                      @click="showImg(data.item.Image01Name)"
                    />
                  </template>
                  <template #cell(Image02Name)="data">
                    <b-img
                      :src="data.item.Image02Name"
                      width="100px"
                      fluid
                      @click="showImg(data.item.Image02Name)"
                    />
                  </template>
                  <template #cell(LPHeadNo)="data">
                    <span
                      style="font-size: 13px;"
                    >
                      {{ data.item.LPHeadNo }} <br> {{ data.item.ProvinceName }}
                    </span>
                  </template>
                  <template #cell(VehicleClassDesc2)="data">
                    <span
                      style="font-size: 13px;"
                    >
                      {{ data.item.VehicleClassDesc2 }}: {{ data.item.VehicleClassDesc3 }}
                    </span>
                  </template>
                  <template #cell(GrossWeight)="data">
                    <span
                      :style="{ color: data.item.IsOverWeight === 'เกินพิกัด' ? 'red' : 'inherit', fontSize: '13px' }"
                    >
                      {{ data.item.GrossWeight }} ตัน
                    </span>
                  </template>
                </b-table>
              </b-col>

              <b-col
                cols="12"
              >
                <b-card-body class="d-flex justify-content-between flex-wrap pt-1">

                  <!-- page length -->
                  <b-form-group
                    label="Per Page"
                    label-cols="6"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPage"
                      size="sm"
                      inline
                      :options="pageOptions"
                    />
                  </b-form-group>

                  <!-- pagination -->
                  <div>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card-code>
        </template>
      </b-col>
    </b-row>
    <!-- <ExportSemControlDay
      ref="childref"
      style="font-size: 20px;"
    /> -->
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BTable, BFormGroup, BBadge, BImg,
  BFormSelect, BPagination, BCardBody, BLink,
  BButton, BInputGroupAppend, BInputGroup, BFormInput, VBModal,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
// import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import axios from '@axios'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
// import ExportSemControlDay from './ExportSemControlDay.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BFormGroup,
    BBadge,
    BImg,
    BFormSelect,
    BPagination,
    BCardBody,
    BButton,
    BLink,
    BInputGroupAppend,
    BInputGroup,
    BFormInput,
    BCardCode,
    flatPickr,
    // ExportSemControlDay,
    // StatisticCardHorizontal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      items: [],
      StationName: '',
      date: {
        wid: this.$route.query.wid,
        dateFrom: '',
        dateTo: '',
      },
      fields: [
        // {
        //   key: 'StationName', label: 'จังหวัด', sortable: true, class: 'text-center',
        // },
        {
          key: 'TimeStamp', label: 'วันที่เวลา', sortable: true, class: 'text-center',
        },
        {
          key: 'VehicleClassDesc2', label: 'ประเภท', sortable: true, class: 'text-center',
        },
        {
          key: 'VehicleClass', label: 'รูปประเภท', sortable: true, class: 'text-center',
        },
        {
          key: 'GrossWeight', label: 'น้ำหนักที่ชั่ง', sortable: true, class: 'text-center',
        },
        {
          key: 'LPHeadNo', label: 'ทะเบียน', sortable: true, class: 'text-center',
        },
        {
          key: 'Image02Name', label: 'รูปทะเบียน', sortable: true, class: 'text-center',
        },
        {
          key: 'Image01Name', label: 'รูปภาพ', sortable: true, class: 'text-center',
        },
        {
          key: 'IsOverWeight', label: 'น้ำหนัก', sortable: true, class: 'text-center',
        },
        {
          key: 'modal', label: 'รายละเอียด', sortable: true, class: 'text-center hidden',
        },
      ],
      // --------history--------
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      IsOverWeight: [{
        เกินพิกัด: 'OVER-GVW', ไม่เกินพิกัด: 'PASS',
      },
      {
        เกินพิกัด: 'light-danger', ไม่เกินพิกัด: 'light-success',
      }],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  created() {
    setInterval(() => {
      this.getHistory()
    }, 300000)
  },
  mounted() {
    this.getHistory()
    this.setToday()
  },
  methods: {
    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const date = 1
      const year = p.getFullYear()
      this.date.dateFrom = `${year}-${month}-${date}`
      this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
    getHistory() {
      axios
        .post('https://drrweb-api.firsttech.co.th/get-Table-WIM', this.date)
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length

          this.StationName = response.data[0].StationName
        })
    },
    showImg(img) {
      this.$swal({
        imageUrl: img,
        imageAlt: 'Custom image',
        width: 800,
        background: 'hsla(0, 100%, 100%, 0)',
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');

.table th{
  border: 1px solid #000000;
  text-align: left;
  padding: 8px;
}
.table td{
  border: 1px solid #000000;
  text-align: left;
  padding: 8px;
}
</style>
